import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import type { AnyMenuItem } from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';
import { MenuItemTestDataAttributes } from 'app/modules/LeftMenu/test-data-helpers';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

type MenuItemProps = {
  entry: AnyMenuItem;
  testDataAttributes: MenuItemTestDataAttributes;
  to: string;
  classNameItem?: string;
  classNameLink?: string;
};

export const MenuItem: React.FC<PropsWithChildren<MenuItemProps>> = ({
  entry,
  classNameItem,
  classNameLink,
  children,
  testDataAttributes,
  to,
}) => {
  const { t } = useTranslation();

  return (
    <li className={classNameItem}>
      <Link
          to={to}
          title={getDictionaryDataItems(t, entry.title)}
          className={classNameLink}
          {...entry.dataGaValues}
          {...testDataAttributes}>
        {children}
      </Link>
    </li>
  );
};
